import {
  DataService,
  GetProductVariantDocument,
  I18nService,
  ModalService,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ChangeDetectorRef,
} from "@angular/core";
import { take } from "rxjs";
import { marker as _ } from "@biesbjerg/ngx-translate-extract-marker";
import {
  GetOrderLinesFromOrderDocument,
  GetOrderLinesFromOrderQuery,
} from "../../generated-graphql/graphql";

@Component({
  selector: "order-expand-content",
  standalone: true,
  templateUrl: "./content.component.html",
  styleUrls: ["./content.component.scss"],
  imports: [SharedModule],
})
export default class OrderExpandContent implements OnInit {
  @Input() item: {
    id: string;
  };
  @Input() index: number;

  @Input()
  readonly: boolean = false;

  orderLines: GetOrderLinesFromOrderQuery["orderLinesByOrderId"] = [];

  constructor(
    private modalService: ModalService,
    private dataService: DataService,
    protected translateService: I18nService,
    protected cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.dataService
      .query(GetOrderLinesFromOrderDocument, {
        orderId: this.item.id,
      })
      .single$.pipe(take(1))
      .subscribe((res) => {
        if (res.orderLinesByOrderId) {
          this.orderLines = res.orderLinesByOrderId;

          this.cdr.markForCheck();
        }
      });
  }
}
